<template>
  <div class="flex flex-wrap">
    <div class="w-full flex items-stretch">
      <h2 class="w-1/2 text-center mx-8 my-2 py-2 text-xl border-b">
        归源易生平台协同中药生产企业共同发展
      </h2>
      <h2 class="w-1/2 text-center mx-8 my-2 py-2 text-xl border-b">
        归源易生平台协同中药生产企业共同开展—— 配方颗粒品种的安全性监测项目
      </h2>
    </div>
    <div class="w-1/2">
      <!-- <h2 class="text-center px-8 pt-4 text-xl sticky top-0">
        归源易生平台协同中药生产企业共同发展
        <el-divider></el-divider>
      </h2> -->
      <div class="contont px-16 pb-4 leading-8 overflow-y-scroll">
        <p>
          国家药监局、国家中医药局、国家卫生健康委、国家医保局于2021年2月10日联合发布（2021年第22号文件）《关于结束中药配方颗粒试点工作的公告》（以下简称《公告》），为加强中药配方颗粒的管理，规范中药配方颗粒的生产，引导产业健康发展，更好满足中医临床需求，研究决定于2021年11月1日结束中药配方颗粒试点工作。
        </p>
        <p><b>配方颗粒相关政策解读——</b><b></b></p>
        <p><b>关键利好：</b><b></b></p>
        <p>1、<b>备案管理</b></p>
        <p>
          如前所述，《公告》第2条明确：“中药配方颗粒品种实施备案管理，不实施批准文号管理，在上市前由生产企业报所在地省级药品监督管理部门备案。”
        </p>
        <p>
          相比较而言，备案管理比药品的批准文号管理进入门槛看似要容易很多，很多企业已经为此积累了很多条件，备案手续为企业简化了流程，节省了时间。
        </p>
        <p><b>2、</b>可进入医保支付</p>
        <p>
          《公告》第9条：“中药配方颗粒不得在医疗机构以外销售。”第10条：“中药饮片品种已纳入医保支付范围的，各省级医保部门可综合考虑临床需要、基金支付能力和价格等因素，经专家评审后将与中药饮片对应的中药配方颗粒纳入支付范围，并参照乙类管理。”
        </p>
        <p>
          可见，《公告》已默认中药配方颗粒可在所有级别医疗机构销售，且国家医保目录内的传统饮片共有892种，已有个别省份将某些中药配方颗粒纳入省级医保支付范围，而公告明确——“各省级医保部门可综合考虑临床需要、基金支付能力和价格等因素，经专家评审后将与中药饮片对应的中药配方颗粒纳入支付范围”，这条原则上会使配方颗粒的使用人群进一步扩大，给配方颗粒企业的销售提升了空间；另外，由于中药配方颗粒具有标准化程度高、方便卫生、便于携带、不易变质等优势，在试点期间已经得到了一部分医疗机构和患者的认可，医保支付层面的相关政策可对该产业的健康持续发展继续产生积极作用。<b
          ></b>
        </p>
        <p><b></b></p>
        <p><b>重要挑战：</b><b></b></p>
        <p><b>1、质量标准与技术要求</b></p>
        <p>
          《公告》一方面规定了中药配方颗粒监管的原则，即“纳入中药饮片管理范畴”；另一方面,国家药典委于2017年便制定了《中药配方颗粒质量控制与标准制定技术要求》，至今已完成160个常用配方颗粒的国家标准,今年1月份，又发布了《中药配方颗粒质量控制与标准制定技术要求》。要求中明确，配方颗粒的制备要具备汤剂的基本属性，提取用溶媒为制药用水，不得使用酸碱、有机溶媒。并要求中药配方颗粒的所有药学研究均须与标准汤剂进行对比。
        </p>
        <p>
          可以说，虽然从申请程序上做了简化，但是，要求中药配方颗粒生产企业具备“中药炮制、提取、分离、浓缩、干燥、制粒等完整的生产能力和相应的生产规模，自行炮制用于中药配方颗粒生产的中药饮片，实施生产全过程管理，建立追溯体系，优先使用来源符合中药材生产质量管理规范要求的中药材种植养殖基地的中药材，提倡使用道地药材……”这些都对中药配方颗粒生产企业提出了细致的要求，为准入的企业划出规范底线。可以说，虽然进入的门槛手续简化了，条件可一点没少，只严不松。
        </p>
        <p>
          《公告》还明确提出：&nbsp;“省级药品监督管理部门应当夯实属地监管职责，承担行政区域内中药配方颗粒的备案工作，强化事中事后管理，加强检查、抽检和监测，对中药材规范化种植养殖基地实施延伸检查，对违法违规行为进行处理。”这也进一步说明，企业需要承担药品全生命周期的主体责任和相关义务，实施生产全过程管理，实现自我合规，要能够应对备案制下的各种监管。
        </p>
        <p><b>2、相关规定要求的技术升级</b><b></b></p>
        <p>
          随着《公告》的出台和生效，势必会有更多的生产企业加入到中药配方颗粒的产业序列之中，因此生产企业应当具备相应的生产能力和生产规模。因为虽然是备案管理，但是要求中药配方颗粒的生产过程应当符合药品生产质量管理规范（GMP）相关要求。可见，
          对中药配方颗粒生产企业严要求，是加强产品质量监管的需要。
        </p>
        <p>
          另外，除了符合药品质量监管要求的配方颗粒产品以外，还要求其监管部门对中药材规范化种植养殖基地实施延伸检查，并且要求“调剂设备应当符合中医临床用药习惯，应当有效防止差错、污染及交叉污染，直接接触中药配方颗粒的材料应当符合药用要求”，
          这意味着配方颗粒药品相关配套产业——GAP基地管理，以及配套调剂技术——调剂设备也要需要技术升级，要能够有效防止差错和调剂过程中的交叉污染。
        </p>
        <p><b>3、监管重中之重——建立</b><b>追溯体系</b></p>
        <p>
          《公告》第4条:“中药配方颗粒生产企业应当履行药品全生命周期的主体责任和相关义务，实施生产全过程管理，建立追溯体系，逐步实现来源可查、去向可追，加强风险管理。”第11条：“使用的调剂软件应对调剂过程实现可追溯。”&nbsp;《公告》第12条还规定直接接触中药配方颗粒包装的标签，至少应当包括备案号、名称、中药饮片执行标准、中药配方颗粒执行标准、规格、生产日期、产品批号、保质期、贮藏、生产企业、生产地址、联系方式等内容。
        </p>
        <p>
          可见，随着中药配方颗粒产业的不断发展，无论是从生产标准化和使用安全性考虑，还是从落实企业主体责任及相关部门有效监管出发，生产企业、医疗机构都需要建立完善追溯体系，以适应当前的实际需要。虽然现代很多中药企业已经进行了数字化转型，但是在整体溯源的规定下，还有很长的技术路线要走。
        </p>
        <p>
          <b>配方颗粒市场亟需解决的技术问题</b><b>——</b><b>高品质的配套软硬件</b
          ><b></b>
        </p>
        <p>
          鉴于《公告》对中药配方颗粒未来发展提出的各种要求，中药配方颗粒市场即将发生重大变化，对于生产企业、医疗机构而言，配置专业标准的调剂设备和建立可靠的追溯体系是亟需解决的问题。
        </p>
        <p>
          以此市场需求为导向，通过自主创新为配方颗粒行业提供高品质的技术服务、为医疗机构提供高品质的智能中药调剂设备的企业——北京恒安众生科技有限公司，是行业内率先提出并做到袋装模式而无交叉污染的。北京恒安众生科技有限公司的智能中药房采用人性化设计，占地面积小，但是功能完善，可以消除调剂过程中产生的粉尘，制袋、调剂、封口、落袋都是自动化完成。在2019年的广州药交会中，由于成本低、符合药品包材规定、调剂过程无交叉污染等诸多因素，已经获得多家配方颗粒企业的关注。目前已迅速与多家中药配方颗粒生产企业达成战略关系，服务300多家医疗机构，辐射25个省级区域，为智能化中药房适应监管的合规化打下良好的基础。
        </p>
        <p class="flex justify-around">
          <img src="@/assets/consultative-img.png" alt="" />
        </p>
        <p>
          从追溯体系上来说，当前行业的追溯手段相对简单且存在弊端，一般追溯系统的中心化特质无法保证数据的可靠性，使得追溯体系系统形同虚设；追溯系统不成体系，缺乏必要的监管，一旦发生纠纷，往往难以取证。
        </p>
        <p>
          北京归源易生软件开发有限公司在技术上进行创新，率先推出了适合配方颗粒溯源的系统平台，据悉该系统平台按医、药两条线设计，利用区块链技术将不同的药品流通参与主体的信息数字化后存进区块链中。涉及药品全流程主体，包含药品注备案号、名称、中药饮片执行标准、中药配方颗粒执行标准、规格、生产日期、产品批号、保质期、贮藏、生产企业、生产地址、联系方式等内容。保证了药品信息透明化，全流程任何环节均可真实追溯，提升了药品安全及可信度，并有利于监管。
        </p>

        <!-- <p><b>项目合作、洽谈请联系——</b><b></b></p>
        <p><b>姓名：王宇鹏</b><b></b></p>
        <p><b>电话：</b><b>1</b><b>13801267590</b><b></b></p>
        <p>
          <b>邮箱：</b><b>yupeng.wang@</b><b>henganpros</b><b>.com</b><b></b>
        </p> -->
      </div>
    </div>
    <div class="w-1/2">
      <!-- <h2 class="text-center px-8 pt-4 text-xl sticky top-0">
        归源易生平台协同中药生产企业共同开展—— 配方颗粒品种的安全性监测项目
        <el-divider></el-divider>
      </h2> -->
      <div class="contont px-16 pb-4 leading-8 overflow-y-scroll">
        <p>
          配方颗粒作为中药饮片的加工产品，也不可避免的会出现饮片所具有的不良反应。
        </p>
        <p>
          中药不良反应的概念：合格中药或者中成药在正常用法用量下出现的与用药目的无关的或者以外的有害反应。但目前,
          中药不良反应的概念界定尚不够明确, 在大多数情况下,
          不合格药品和用药不当等造成的药害事件也都被包括在中药不良反应当中。
        </p>
        <p>
          归源易生平台可以与中药企业协同开展配方颗粒临床使用的安全性监测项目，医生在临床过程中，每当发现与之有关的不良事件后，可以随时反馈给中药企业，中药企业与归源技术协同平台积极溯源，并按照及时有效的不良反应反馈机制，在规定时间内给予反馈。
        </p>
        <p>
          归源易生平台协同企业对不良事件定期汇总。以每一个自然年为一个监测持续周期。在监测期内，以各医院使用该企业某配方颗粒中药品种的患者数量作为不良反应监测项目的覆盖人群数量，一年期满后进行统计分析，形成总结报告。
        </p>
        <p>
          通过连续监测可对配方颗粒中药产品的临床安全性进行研究，并可对其中的毒性药材品种进行重点监测，连续监测中如发现安全性风险信号，则归源易生平台协同药品生产企业进行有针对性地重点品种评价，以明确其不良反应的类型、发生率和影响因素，依据同品种饮片资料以及临床监测所发现的不良事件及非预期的不良事件等进行重点研究与评价。并可依据监测情况及不良事件发生情况开展对于中医师的相关中药不良反应培训工作。部分安全性监测研究可与企业开展的临床研究一起进行。
        </p>
        <p>
          目前，归源易生技术协同平台已建立起面向医生临证端的中药药品不良反应监测提醒——对医生临证时已实现以下内容：
        </p>
        <ul>
          <li>处方十八反、十九畏检验提醒</li>
          <li>处方中药毒性药品标识</li>
          <li>处方中药毒性药品超出药典建议剂量提示</li>
        </ul>
        <p><b>项目意义——</b><b></b></p>
        <p>
          开展中药产品——包括配方颗粒产品的安全性监测研究，其意义可以从以下五个方面阐述：
        </p>
        <ul>
          <li>
            1、从政府的层面来说：满足对中药饮片及配方颗粒企业的监管要求，实现医院-企业-政府三方共同构建完备的监测体系。加强药品不良反应监测可以提高治疗质量、降低医疗费用、减轻患者负担。
          </li>
          <li>
            2、从医生的层面来说：可以对中医临床医生进行药品不良反应相关培训，提升中医临床规范性，加强中药临床使用的安全性；
          </li>
          <li>
            3、从企业的层面来说：建立了企业应对不良反应的快速反馈机制；提供产品的差异化服务，提升企业销售地位，便于市场销售人员与医生塑造“伙伴”关系；为未来产品的市场推广提供学术支持和助力；企业承担了应尽的社会责任，提升了公司的美誉度；
          </li>
          <li>
            4、从产品层面来说：提高了中药产品的抗风险能力，建立起良好的产品品牌形象，在行业竞争中突显实力。
          </li>
          <li>
            5、对于生产厂家，药品出现不良反应是正常的，出现质量问题或者瞒报才是严重的，及时、主动报告不良反应，是药品生产企业和临床医生具有高度责任心的表现。
          </li>
        </ul>
        <!-- <p><b>项目合作、洽谈请联系——</b><b></b></p>
        <p><b>姓名：王宇鹏</b><b></b></p>
        <p><b>电话：</b><b>1</b><b>13801267590</b><b></b></p>
        <p><b>邮箱：</b><b>yupeng.wang@241210.com</b><b></b></p> -->
      </div>
    </div>
    <div class="w-full text-center py-2">
      <p>
        <b>项目合作、洽谈请联系——</b>
        <b>王宇鹏</b>
        <b class="ml-8">电话：13801267590</b>
        <b class="ml-8">
          邮箱：
          <a href="mailto:yupeng.wang@241210.com"> yupeng.wang@241210.com </a>
        </b>
        <b class="ml-4">
          <a href="mailto:yupeng.wang@henganpros.com">
            yupeng.wang@henganpros.com
          </a>
        </b>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "consultative",
};
</script>

<style lang="less" scoped>
.contont {
  // 页头页脚160px，
  // h2高度89px
  // 合作部分40px
  height: calc(100vh - 160px - 89px - 40px);
  text-indent: 32px;
}
</style>
